import React from 'react';
import { cn } from '../../utils/cn';
import CogitoLogo from './CogitoLogo';
import Icon from '../AppIcon';

const SmartLoadingBuffer = ({
  title = 'Calibrating your learning loop',
  message = 'Cogito is syncing your personalized insights.',
  hint = 'This usually takes just a moment.',
  showLogo = true,
  className = '',
  children
}) => {
  return (
    <div className={cn('w-full flex flex-col items-center justify-center py-16 px-4 text-center space-y-8', className)}>
      {showLogo && (
        <div className="relative">
          <div className="absolute -inset-6 rounded-3xl bg-primary/20 blur-3xl opacity-70 animate-pulse" aria-hidden />
          <CogitoLogo size="md" interactive={false} tagline="thinking ahead" />
        </div>
      )}

      <div className="space-y-3 max-w-md">
        <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium uppercase tracking-wide">
          <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          <span>Smart loading</span>
        </div>
        <h2 className="text-2xl font-semibold text-foreground leading-snug">{title}</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">{message}</p>
      </div>

      <div className="w-full max-w-sm">
        <div className="relative h-2 bg-muted/60 rounded-full overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-primary via-accent to-primary animate-[pulse_2.4s_ease-in-out_infinite]" />
        </div>
        <div className="mt-4 flex items-center justify-center text-xs text-muted-foreground space-x-2">
          <Icon name="Sparkles" size={14} className="text-primary" />
          <span>{hint}</span>
        </div>
      </div>

      {children && (
        <div className="w-full max-w-md text-sm text-muted-foreground/80">
          {children}
        </div>
      )}
    </div>
  );
};

export default SmartLoadingBuffer;
